import type { PlacePhoto } from '../types/place'

const webpByFile = import.meta.glob('../../rezerwat-wodospad-wilczki/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>

function urlForFile(file: string): string | null {
  const entry = Object.entries(webpByFile).find(([key]) => key.replace(/\\/g, '/').endsWith(`/${file}`))
  return entry?.[1] ?? null
}

const PHOTOS: { file: string; alt: string }[] = [
  {
    file: 'wodospad-wilczki-glowna.webp',
    alt: 'Wodospad Wilczki w rezerwacie przyrody — główny widok na kaskadę wodną w Masywie Śnieżnika',
  },
  {
    file: 'wodospad.webp',
    alt: 'Wodospad Wilczki koło Międzygórza — strumień spadający po skalnym progu w zielonym wąwozie',
  },
  {
    file: 'wodospad-sudety-miedzygorze.webp',
    alt: 'Wodospad Wilczki — widok na wodospad i okolicę Międzygórza w Sudetach',
  },
  {
    file: 'wodospad-wilczki-park.webp',
    alt: 'Park i zieleń w rezerwacie Wodospad Wilczki — alejka w stronę atrakcji',
  },
  {
    file: 'wodospad-wilczki-park-2.webp',
    alt: 'Zielony park w rezerwacie Wodospad Wilczki — spacer po terenie chronionym',
  },
  {
    file: 'wejscie-rezerwat-wilczki.webp',
    alt: 'Wejście do rezerwatu przyrody Wodospad Wilczki koło Międzygórza',
  },
  {
    file: 'wodospad-wilczki-znak.webp',
    alt: 'Znak i oznaczenie szlaku przy Wodospadzie Wilczki w rezerwacie',
  },
  {
    file: 'rezerwat-wodospad-wilczki-aplikacja.webp',
    alt: 'Rezerwat Wodospad Wilczki — widok na teren rezerwatu i otaczającą przyrodę Sudetów',
  },
]

function photosFromEntries(entries: { file: string; alt: string }[]): PlacePhoto[] {
  return entries.flatMap((p) => {
    const src = urlForFile(p.file)
    if (!src) return []
    return [{ src, alt: p.alt }]
  })
}

export const wodospadWilczkiPhotos: PlacePhoto[] = photosFromEntries(PHOTOS)

/** Obraz wyróżniający artykułu i meta OG. */
export const wodospadWilczkiFeaturedPhoto: PlacePhoto | undefined = wodospadWilczkiPhotos[0]
